export const gaClient = '_ga';
